module.exports = {
	"id": "KZ",
	"name": "Kazakhstan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.167854,
			"5": 0.14596,
			"6": 0.116768,
			"7": 0.07298,
			"8": 0.087576,
			"9": 0.07298,
			"10": 0.116768,
			"11": 0.116768,
			"12": 0.14596,
			"13": 0.102172,
			"14": 0.167854,
			"15": 0.240834,
			"16": 0.226238,
			"17": 0.284622,
			"18": 0.29192,
			"19": 0.262728,
			"20": 0.226238,
			"21": 0.386794,
			"22": 0.321112,
			"23": 0.299218,
			"24": 0.299218,
			"25": 0.270026,
			"26": 0.270026,
			"27": 0.270026,
			"28": 0.175152,
			"29": 0.065682,
			"30": 0.043788,
			"31": 0.116768,
			"32": 0.080278,
			"33": 0.087576,
			"34": 0.065682,
			"35": 0.21894,
			"36": 0.07298,
			"37": 0.10947,
			"38": 0.131364,
			"39": 0.32841,
			"40": 0.3649,
			"41": 0.189748,
			"42": 0.226238,
			"43": 0.32841,
			"44": 0.051086,
			"45": 0.124066,
			"46": 0.058384,
			"47": 0.087576,
			"48": 0.189748,
			"49": 1.49609,
			"50": 0.226238,
			"51": 0.664118,
			"52": 0.459774,
			"53": 18.033358,
			"54": 5.174282,
			"55": 0.18245,
			"56": 0.058384,
			"57": null
		},
		"firefox": {
			"2": 0.175152,
			"3": 0.481668,
			"4": 0.102172,
			"5": 0.065682,
			"6": 0.029192,
			"7": 0.021894,
			"8": 0.051086,
			"9": 0.058384,
			"10": 0.102172,
			"11": 0.080278,
			"12": 0.03649,
			"13": 0.03649,
			"14": 0.102172,
			"15": 0.080278,
			"16": 0.102172,
			"17": 0.03649,
			"18": 0.03649,
			"19": 0.043788,
			"20": 0.065682,
			"21": 0.087576,
			"22": 0.03649,
			"23": 0.043788,
			"24": 0.07298,
			"25": 0.07298,
			"26": 0.065682,
			"27": 0.021894,
			"28": 0.03649,
			"29": 0.03649,
			"30": 0.029192,
			"31": 0.058384,
			"32": 0.07298,
			"33": 0.058384,
			"34": 0.10947,
			"35": 0.175152,
			"36": 0.10947,
			"37": 0.029192,
			"38": 0.10947,
			"39": 0.021894,
			"40": 0.021894,
			"41": 0.014596,
			"42": 0.029192,
			"43": 0.14596,
			"44": 0.029192,
			"45": 0.116768,
			"46": 0.080278,
			"47": 0.452476,
			"48": 0.226238,
			"49": 3.700086,
			"50": 0.007298,
			"51": null,
			"52": null,
			"3.5": 0.861164,
			"3.6": 2.474022
		},
		"opera": {
			"9": null,
			"11": 0.10947,
			"12": 0.941442,
			"15": 0.029192,
			"16": 0.021894,
			"17": 0.029192,
			"18": 0.080278,
			"19": 0.014596,
			"20": 0.131364,
			"21": 0.087576,
			"22": 0.029192,
			"23": 0.058384,
			"24": 0.065682,
			"25": 0.043788,
			"26": 0.065682,
			"27": 0.58384,
			"28": 0.029192,
			"29": 0.03649,
			"30": 0.029192,
			"31": 0.007298,
			"32": null,
			"33": 0.007298,
			"34": 0.021894,
			"35": 0.029192,
			"36": 0.18245,
			"37": 0.065682,
			"38": 0.116768,
			"39": 0.065682,
			"40": 2.379148,
			"41": 0.3649,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.10947,
			"10.5": 0.167854,
			"10.6": 0.3649,
			"11.1": 0.131364,
			"11.5": 0.204344,
			"11.6": 0.831972,
			"12.1": 2.95569
		},
		"safari": {
			"0": null,
			"4": 0.408688,
			"5": 0.561946,
			"6": 0.102172,
			"7": 0.029192,
			"8": 0.094874,
			"9": 0.03649,
			"10": 0.408688,
			"3.1": 0.065682,
			"3.2": 0.043788,
			"5.1": 0.357602,
			"6.1": 0.03649,
			"7.1": null,
			"9.1": 0.270026
		},
		"ios_saf": {
			"8": 0,
			"10": 3.59441593006,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0968653501249,
			"8.1-8.4": 0.178954629892,
			"9.0-9.2": 0.0853728509575,
			"9.3": 1.30248323897
		},
		"android": {
			"3": 0,
			"4": 0.0356286976744,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0044535872093,
			"4.1": 0.128517802326,
			"4.2-4.3": 0.321294505814,
			"4.4": 0.736750569767,
			"4.4.3-4.4.4": 0.743112837209
		},
		"ie": {
			"6": 0.0158396053812,
			"7": 0.00791980269058,
			"8": 0.689022834081,
			"9": 0.395990134529,
			"10": 0.799900071749,
			"11": 1.62355955157,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0754665123058,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0020962920085
		},
		"edge": {
			"12": 0.029192,
			"13": 0.160556,
			"14": 0.415986
		},
		"ie_mob": {
			"10": 0.0420903098592,
			"11": 0.171367690141
		},
		"bb": {
			"7": 0.0047285,
			"10": null
		},
		"samsung": {
			"0": 2.59392
		},
		"and_uc": {
			"0": 1.523928
		},
		"op_mini": {
			"0": 1.01674719569
		},
		"and_chr": {
			"0": 15.476012
		},
		"and_ff": {
			"0": 0.008106
		}
	},
	"total": 90.5767025
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KZ.json
 ** module id = 570
 ** module chunks = 0
 **/